import React from "react";
import __pages_import_0__ from "/pages/index.tsx";
const __pages_import_1__ = React.lazy(() => import("/pages/testroute.tsx"));

const routes = [{"caseSensitive":false,"path":"/","element":React.createElement(__pages_import_0__)},{"caseSensitive":false,"path":"testroute","element":React.createElement(__pages_import_1__)}];

export default routes;